import { Table } from '../../../../../common/components';
import { PayOffInfoTableColumns } from '../../../../../utils/constant';
import { getPrice } from '../../../../../utils/formatters';

const PayOffInfoTable = ({ data }) => {
  return (
    <Table
      className="dashboard-table pay-off-table pay-off-info"
      bordered
      responsive
      headers={PayOffInfoTableColumns}
    >
      <tbody>
        <tr>
          <td>{getPrice(data?.originalPrincipal)}</td>
          <td>{getPrice(data?.originalInterest)}</td>
          <td>{getPrice(data?.payOffAmount)}</td>
          <td>{getPrice(data?.interestSave)}</td>
          <td>{getPrice(data?.interestPaid)}</td>
          <td>{getPrice(data?.amountPaid)}</td>
        </tr>
      </tbody>
    </Table>
  );
};

export default PayOffInfoTable;
